import HttpClienteToken from '../../services/HttpClientToken';

import { EstatusProps } from '../../interfaces/catalogos/EstatusInterface';

export const Estatus = () => {

    return new Promise<EstatusProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Estatus/', token)
            .then( ({ data } : { data : EstatusProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerEstatus = () => {

    return new Promise<EstatusProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Estatus/ObtenerEstatus', token)
            .then( ({ data } : { data : EstatusProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarEstatus = ( params: EstatusProps ) => {

    return new Promise<EstatusProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Estatus/Actualizar', params, token)
            .then( ({ data } : { data : EstatusProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idEstatus: 0,                 
                    descripcion: '',
                    activo: false,     
                });
            });
        }

    });

}

export const AgregarEstatus = ( params: EstatusProps ) => {

    return new Promise<EstatusProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Estatus/Agregar', params, token)
            .then( ({ data } : { data : EstatusProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idEstatus: 0,                   
                    descripcion: '',
                    activo: false,    
                });
            });
        }

    });

}